export default __webpack_public_path__ + "static/media/renuma-plus-05-2.7d95d173.png";